<template>
  <div class="dialog">
    <el-dialog
      :visible.sync="changVisible"
      title="新增管理员"
      center
      width="600px"
      :before-close="$onClose"
      destroy-on-close
      @close="close()"
    >
      <div>
        <div>
          <h4 class="title">管理员姓名</h4>
          <el-input v-model="name" placeholder="请输入"></el-input>
        </div>
        <div>
          <h4 class="title">账号</h4>
          <el-input v-model="user" placeholder="请输入"></el-input>
        </div>
        <div>
          <h4 class="title">密码</h4>
          <el-input
            v-model="passwd"
            placeholder="请输入"
            type="password"
          ></el-input>
        </div>
        <div>
          <h4 class="title">所属角色</h4>
          <el-select class="input" v-model="power" placeholder="请选择">
            <el-option
              v-for="item in powerOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
      </div>

      <div class="footDialog">
        <el-button
          style="width: 106px; float: right"
          size="small"
          type="primary"
          v-preventReClick
          @click="save()"
          >保存</el-button
        >
        <el-button
          style="width: 106px; float: right; margin-right: 15px"
          size="small"
          @click="close()"
          >取消</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { isEmpty } from "@/utils/strUtils";
import preventReClick from "@/utils//preventReClick"; //防多次点击，重复提交
import * as Constant from "@/utils/constant.js";

export default {
  data() {
    return {
      changVisible: false,

      role_list: [],
      powerOptions: [],
      user: "",
      name: "",
      passwd: "",
      power: 0,
    };
  },
  methods: {
    $onClose(done) {
      done();
    },
    close() {
      this.changVisible = false;
      this.role_list = [];
      this.powerOptions = [];
      this.user = "";
      this.name = "";
      this.passwd = "";
      this.power = 0;
    },
    save() {
      let clickNow = new Date().valueOf();
      if (clickNow - this.clickLastTime < 2000) return;
      this.clickLastTime = clickNow;
      if (
        isEmpty(this.user) ||
        isEmpty(this.name) ||
        isEmpty(this.passwd) ||
        isEmpty(this.power)
      ) {
        this.$message.error("请完善信息");
        return;
      }
      if (this.user.length > 12 || this.user.length < 6) {
        this.$message.error("账号长度必须在6到12位之间");
        return;
      }
      if (this.passwd.length > 20 || this.passwd.length < 6) {
        this.$message.error("密码长度必须在6到20位之间");
        return;
      }
      this.createAdminUser();
    },
    //页面初始化时加载的事件
    show() {
      this.changVisible = true;
      this.powerTemplateList();
    },
    // 获取角色列表
    powerTemplateList: function () {
      this.$api
        .powerTemplateList({
          token: localStorage.getItem("token"),
        })
        .then(({ data }) => {
          this.role_list = data.Data;
          this.role_list.forEach((role) => {
            this.powerOptions.push({
              value: role.id,
              label: role.template_cn,
            });
          });
        })
        .catch(({ error }) => {});
    },
    // 新增管理员
    createAdminUser: function () {
      this.$api
        .createAdminUser({
          token: localStorage.getItem("token"),
          user: this.user,
          name: this.name,
          passwd: this.passwd,
          power: this.power,
        })
        .then(({ data }) => {
          this.$emit("toSave");
          this.close();
        })
        .catch(({ error }) => {});
    },
  },
};
</script>

<style lang="less" scoped>
.body .title {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/adminAddDialog.vue